export function replaceElement<T>(src: T[], matchOldElement: ((value: T, index: number) => boolean), newElement: T): T[] {
    return src.map((el, index) => matchOldElement(el, index) ? newElement : el);
}

export function replaceElementByIndex<T>(src: T[], indexOf: number, newElement: T): T[] {
    return [
        ...src.slice(0, indexOf),
        newElement,
        ...src.slice(indexOf + 1),
    ];
}

export function insertFirstElement<T>(src: T[], newElement: T): T[] {
    return [
        newElement,
        ...src,
    ];
}

export function appendElement<T>(src: T[], newElement: T): T[] {
    return [
        ...src,
        newElement,
    ];
}

export function deleteElement<T>(src: T[], oldElement: T): T[] {
    return src.filter((value) => (value !== oldElement) && ((value as any).id !== (oldElement as any).id));
}

export function deleteElementByIndex<T>(src: T[], index: number): T[] {
    return [
        ...src.slice(0, index),
        ...src.slice(index + 1),
    ];
}

export function filterNotNull<T>(src: readonly T[]): NonNullable<T>[] {
    return src.filter((it): it is NonNullable<T> => it !== null && it !== undefined);
}

export function mapNotNull<S, T>(src: readonly S[], callbackFn: (value: S, index: number, array: readonly S[]) => T): NonNullable<T>[] {
    return filterNotNull(src.map(callbackFn));
}
